import { TableCell, TableRow, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { palette, spaces } from '../../assets/styles/themes/tokens';

interface InvoiceTableEmptyRowProps {
	colSpan: number;
}

const InvoiceTableEmptyRow = ({ colSpan }: InvoiceTableEmptyRowProps) => {
	const { t } = useTranslation();

	return (
		<TableRow>
			<TableCell colSpan={colSpan}>
				<Typography variant="body2" color={palette.text.secondary} sx={{ padding: spaces.md }}>
					{t('No invoices found')}
				</Typography>
			</TableCell>
		</TableRow>
	);
};

export default InvoiceTableEmptyRow;
